import { app } from "../../config/constants"
import * as usersActions from './actions'
import {store} from "../../reducers"

export const write = ( user ) => {
	return new Promise( ( resolve, reject ) => {
		app.database().ref('/cams/users').orderByChild('wordpressId').equalTo(user.wordpressId).once('value', (users) => {
			if (null === users.val()) {
				app.database().ref('/cams/users').push(user).then(userSnap => {
					resolve();
				});
			} else {
				users.forEach((userSnap) => {
					resolve();
					app.database().ref('/cams/users').child(userSnap.key).set(user).then(userSnap => {
						resolve();
					});
				});
			}
		});
	} );
};

export const loadUsers = () => {
	const ref = app.database().ref('/cams/users');

	ref.orderByChild( 'name' ).once('value', (users) => {
		store.dispatch(usersActions.addUsers(users));
	});
};


// WEBPACK FOOTER //
// ./src/api/users/index.js